import React, { createContext, useState, ReactNode } from 'react';
import { TypeStore } from 'types/TypeStoreProps';

interface TypeStoreContextProps {
	typeStore: TypeStore;
	setTypeStore: React.Dispatch<React.SetStateAction<TypeStore>>;
}

const TypeStoreContext = createContext<TypeStoreContextProps>({
	typeStore: 'default',
	setTypeStore: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function TypeStoreProvider({ children }: ContextProps) {
	const [typeStore, setTypeStore] = useState<TypeStore>('default');

	return (
		<TypeStoreContext.Provider value={{ typeStore, setTypeStore }}>
			{children}
		</TypeStoreContext.Provider>
	);
}

export default TypeStoreContext;
